import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BusinessDataService } from "src/app/services/business-data.service";
import { MatchValidator } from "src/app/tools/match.validator";

@Component({
    selector: "ow-business-data-form",
    templateUrl: "./business-data-form.component.html"
})
export class BusinessDataFormComponent implements OnInit, OnDestroy {

    @Output() updateValidity = new EventEmitter<boolean>(false)
      
    private readonly businessDataService = inject(BusinessDataService)

  public readonly form = new FormGroup({
    companyName: new FormControl<string>(this.businessDataService.getBusinessData().companyName, [Validators.required, Validators.maxLength(25)]),
    invoiceStreetAddress: new FormControl<string>(this.businessDataService.getBusinessData().invoiceStreetAddress, [Validators.required]),
    invoicePostalCode: new FormControl<string>(this.businessDataService.getBusinessData().invoicePostalCode, [Validators.required]),
    invoiceCity: new FormControl<string>(this.businessDataService.getBusinessData().invoiceCity, [Validators.required]),
    contactEmail: new FormControl<string | null>(this.businessDataService.getBusinessData().contactEmail, [
      Validators.required,
      Validators.email
    ]),
    contactEmailConfirmation: new FormControl<string | null>(this.businessDataService.getBusinessData().contactEmailConfirmation, [
      Validators.required,
      Validators.email
    ]),
    invoiceAgreementNumber: new FormControl<string>(this.businessDataService.getBusinessData().invoiceAgreementNumber, [Validators.required]),
    invoiceReference: new FormControl<string>(this.businessDataService.getBusinessData().invoiceReference, [])
  })

  private readonly subscriptions = [
    this.form.controls.companyName.valueChanges.subscribe((value) => {
      if (this.form.controls.companyName.valid) {
        this.businessDataService.setBusinessData({ companyName: value! })
      }
    }),
    this.form.controls.invoiceStreetAddress.valueChanges.subscribe((value) => {
        if (this.form.controls.invoiceStreetAddress.valid) {
          this.businessDataService.setBusinessData({ invoiceStreetAddress: value! })
        }
      }),
      this.form.controls.invoicePostalCode.valueChanges.subscribe((value) => {
        if (this.form.controls.invoicePostalCode.valid) {
          this.businessDataService.setBusinessData({ invoicePostalCode: value! })
        }
      }),
      this.form.controls.invoiceCity.valueChanges.subscribe((value) => {
        if (this.form.controls.invoiceCity.valid) {
          this.businessDataService.setBusinessData({ invoiceCity: value! })
        }
      }),
    this.form.controls.contactEmail.valueChanges.subscribe((value) => {
      if (this.form.controls.contactEmail.valid) {
        this.businessDataService.setBusinessData({ contactEmail: value! })
      }
      this.form.controls.contactEmailConfirmation.updateValueAndValidity()
    }),
    this.form.controls.contactEmailConfirmation.valueChanges.subscribe((value) => {
      if (this.form.controls.contactEmailConfirmation.valid) {
        this.businessDataService.setBusinessData({ contactEmailConfirmation: value! })
      }
    }),
    this.form.controls.invoiceAgreementNumber.valueChanges.subscribe((value) => {
        if (this.form.controls.invoiceAgreementNumber.valid) {
          this.businessDataService.setBusinessData({ invoiceAgreementNumber: value! })
        }
      }),
      this.form.controls.invoiceReference.valueChanges.subscribe((value) => {
        if (this.form.controls.invoiceReference.valid) {
          this.businessDataService.setBusinessData({ invoiceReference: value! })
        }
      }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.form.controls.contactEmailConfirmation.addValidators(MatchValidator(this.form.controls.contactEmail))
    this.form.controls.contactEmailConfirmation.updateValueAndValidity()
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

}
